module.exports = __webpack_public_path__ + "img/hands-helping.873757b3.svg";